import React from 'react';
import { getAnadoluBrandLogoSrc } from '../../utils/portal-auth';

export const AnadoluLogo = ({
  className = 'h-auto w-[140px]',
}: {
  className?: string;
}) => (
  <img
    src={getAnadoluBrandLogoSrc()}
    alt="ANADOLU"
    className={className}
  />
);
